/**
 * intc-spec-line-sync.js
 *
 * Keeps the Model spec line (snippets/intc-spec-line.liquid) in sync with
 * the selected variant. assets/product-info.js only refreshes a fixed set of
 * element ids after a variant change (price-<sectionId>, Sku-<sectionId>,
 * etc.) — the spec line isn't among those ids, so it stays frozen on
 * whichever variant loaded first. Subscribing to PUB_SUB_EVENTS.variantChange
 * here avoids editing the hard-gated product-info.js, same approach as
 * intc-sticky-atc-sync.js.
 */
(function () {
  'use strict';

  function intcModelFromSku(sku) {
    if (!sku) return '';
    return sku.split('-')[0];
  }

  function intcUpdateSpecLine(sectionId, variant) {
    var specLine = document.querySelector('.intc-pdp-spec-line[data-section-id="' + sectionId + '"]');
    if (!specLine) return;

    if (!variant) {
      specLine.hidden = true;
      return;
    }

    // UPC (variant barcode) is internal and deliberately not shown.
    var model = intcModelFromSku(variant.sku);
    specLine.innerHTML = model ? '<span class="intc-pdp-spec-line__item">Model ' + model + '</span>' : '';
    specLine.hidden = !model;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event.data;
      if (!data) return;
      intcUpdateSpecLine(data.sectionId, data.variant);
    });
  }
})();
